<template>
    <div class="wraper">
        <div v-if="course == null"  v-loading="loading">
        </div>
        <div v-else>
            <el-row style="margin-top:10px">
                <el-col :xs="24" :md="6">
                    <img v-if="course.imageUrl" id="img-courses" :src="course.imageUrl" alt="">
                    <img v-else id="img-courses" src="@/assets/images/courseDefault.png" alt="">
                </el-col>
                <el-col :xs="24" :md="18" id="course-container">
                    <el-row >
                        <el-col :xs="24" :sm="24" :md="20" id="top-section-view">
                            <h1 id="myCourse-name">{{ course.name }}</h1>
                            <complete-porcent  :courseId="course._id"></complete-porcent>
                            <div>
                                <p v-loading="loadingScore" id="totalScore">Nota: {{ score }}</p>
                            </div>
                            <router-link id="program-link" :to="{ name: 'Program', params: { id: course._id } }" > Ver Programa <span class="el-icon-view"></span> </router-link>                     
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="4">
                            <button-continue :courseId="course._id"></button-continue>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import completePorcent from '@/components/courses/completePorcent'
import buttonContinue from '@/components/courses/buttonContinue'
import { getInscriptionByCourse } from '@/requests/inscriptions'
import { getCourse } from '@/requests/courses'
export default {
    props: [ 'courseId' ],
    components: { completePorcent, buttonContinue },
    data(){
        return { 
            loading: false,
            loadingScore: false,
            course: null,
            score: '--'
        }
    },
    mounted() {
        this.loadingScore = true
        getCourse({ id: this.courseId })
        .then((respuesta)=>{
            
            if(respuesta.isPublished && respuesta.isVisible){

                getInscriptionByCourse({ userId: this.$session.get('userId'), courseId: this.courseId })
                .then((response)=>{
                    let ins = response.items[0]
                    this.course = respuesta
                    if(ins){
                        
                        if(ins.isApproved){
                            var allScore = 0
                            var count = 0
                            for (let i = 0; i < ins.results.length; i++) {
                                if(ins.results[i].score){
                                    allScore = allScore + ins.results[i].score
                                    count++
                                }
                                
                            }
                            this.score = Math.round(allScore/count)
                            this.loadingScore = false
                        }                   
                    }        
                })
            }
             this.loadingScore = false
        })
       
    }
    
}
</script>

<style>
    
</style>



// WEBPACK FOOTER //
// src/components/courses/myCourses/viewAllcourses.vue